import { createURL } from 'expo-linking';
import { Platform } from 'react-native';

import { getEnvVars } from '@order/utils';

// ─────────────────────────────────────────────────────────────────────────────

export const idMeConfig = readIdMeConfig();
export const isIdMeConfigured = idMeConfig.clientId.length > 0;
export const hasPersistentIdMeSession = Platform.OS === 'web';

// ─── Helpers ─────────────────────────────────────────────────────────────────

function readIdMeConfig() {
  const { IDME_CLIENT_ID, IDME_SCOPE, IDME_NATIVE_REDIRECT_URI, IDME_BASE_URL, IDME_GROUPS_URL } =
    getEnvVars();

  return {
    clientId: IDME_CLIENT_ID ?? '',
    scopes: parseScopes(IDME_SCOPE),
    redirectUri: getRedirectUri(IDME_NATIVE_REDIRECT_URI),
    logoutEndpoint: `${IDME_BASE_URL ?? 'https://api.id.me'}/oauth/logout`,
    discovery: {
      // NOTE: `api.id.me` rejects several communities with `invalid_scope`; this host takes a list.
      authorizationEndpoint: IDME_GROUPS_URL ?? 'https://groups.id.me',
    },
  };
}

function parseScopes(rawScopes: unknown) {
  const scopes = typeof rawScopes === 'string' ? rawScopes.split(',') : [];
  const trimmedScopes = scopes.map(trimScope).filter(Boolean);

  return trimmedScopes.length > 0 ? trimmedScopes : ['student'];
}

/**
 * NOTE: ID.me registers only `https://` and `http://localhost` redirect URIs.
 * @param nativeRedirectUri
 */
function getRedirectUri(nativeRedirectUri: string | undefined) {
  if (Platform.OS === 'web') {
    return createURL('id-me');
  }

  return nativeRedirectUri ?? 'https://order-development.sweetgreen.com/id-me';
}

function trimScope(scope: string) {
  return scope.trim();
}
